// frontend/src/main.jsx
//
// Application bootstrap — minimal by design.
// RouterProvider from React Router v6 takes the router config and
// handles everything: URL matching, lazy loading, history management.

import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { router } from './router'
import './i18n/index.js'
import './styles/global.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
)
